export enum PortalUserRoleCode{
    None = 0,
    User = 1,
    Host = 2,
    Admin = 4
}